import CellPrice from '@/components/GokuDataGrid/CellPrice'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { ServiceCost } from '../types'
import { Chip } from 'vnetwork-ui'
import CellDate from '@/components/GokuDataGrid/CellDate'

export const columns: GridColDefVNW<ServiceCost>[] = [
    {
        field: 'cost_month',
        headerName: 'cost_month',
        width: 120,
        renderCell: ({ value }) => (
            <CellDate date={value + '-01'} scope="MMM, YYYY" />
        ),
    },
    {
        field: 'cost_type',
        headerName: 'cost_type',
        width: 130,
        renderCell: ({ value }) => {
            if (value === 'shared') {
                return (
                    <Chip
                        label="Chi phí chung"
                        color="primary"
                        variant="outlined"
                        size="small"
                    />
                )
            }
            return (
                <Chip
                    label="Chi phí riêng"
                    color="success"
                    variant="outlined"
                    size="small"
                />
            )
        },
    },
    {
        field: 'product_group_name',
        headerName: 'product_group_name',
        width: 300,
        renderCell: ({ value }) => {
            if (!value) {
                return <span className="text-gray-400 italic">N/A</span>
            }
            return value
        },
    },
    {
        field: 'cost_amount',
        headerName: 'cost_amount',
        width: 180,
        renderCell: ({ value }) => {
            return <CellPrice price={value} className="text-orange-700" />
        },
    },
    {
        field: 'notes',
        headerName: 'notes',
        width: 300,
        renderCell: ({ value }) => {
            if (!value) return <span className="text-gray-400 italic">-</span>
            return <span className="text-sm">{value}</span>
        },
    },
    {
        field: 'description',
        headerName: 'description',
        width: 300,
        renderCell: ({ value }) => {
            if (!value) return <span className="text-gray-400 italic">-</span>
            return <span className="text-sm text-gray-600">{value}</span>
        },
    },
]
